import { AppThunk } from 'src/store/store';
import {
  setRenewableLicenses,
  setRenewableLicensesFailure,
  setRenewableLicensesLoading,
  setUserLicenses,
  setUserLicensesFailure,
  setUserLicensesLoading,
} from './userLicensesSlice';
import api from 'src/api';
import { selectCurrentIDToken } from '../auth/authSelectors';
import { License } from 'src/types/licenses';

export const getUserLicensesAsync = (
  forceRefresh: boolean = false
): AppThunk<void, typeof api> => {
  return async (dispatch, getState, api) => {
    const accessToken = selectCurrentIDToken(getState());
    dispatch(setUserLicensesLoading(true));
    try {
      let contToken = 0;
      let pagesLoaded: number[] = [];
      let currentData: License[] = [];
      if (!forceRefresh) {
        contToken = getState().userLicenses.userLicenses.nextContToken || 0;
        pagesLoaded = getState().userLicenses.userLicenses.pagesLoaded || [];
        currentData = getState().userLicenses.userLicenses.data;
        if (!contToken && contToken !== 0) {
          dispatch(setUserLicensesLoading(false));
          return;
        }
        if (pagesLoaded.includes(contToken)) {
          dispatch(setUserLicensesLoading(false));
          return;
        }
      }
      const data = await api.getUserLicenses(accessToken, contToken);
      dispatch(
        setUserLicenses({
          data: [...currentData, ...data.data],
          contToken,
          nextContToken: data.contToken,
          pagesLoaded: [...pagesLoaded, contToken],
        })
      );
      if (data.contToken !== null) {
        dispatch(getUserLicensesAsync());
      }
    } catch (error) {
      console.error('error loading user licenses', error);
      dispatch(
        setUserLicensesFailure(
          'Something went wrong while fetching user licneses.'
        )
      );
    }
  };
};

export const getUsersRenewableLicensesAsync = (
  forceRefresh: boolean = false
): AppThunk<void, typeof api> => {
  return async (dispatch, getState, api) => {
    dispatch(setRenewableLicensesLoading(true));
    try {
      let contToken = 0;
      let pagesLoaded: number[] = [];
      let currentData: License[] = [];
      if (!forceRefresh) {
        currentData = getState().userLicenses.renewableLicenses.data;
        contToken =
          getState().userLicenses.renewableLicenses.nextContToken || 0;

        pagesLoaded =
          getState().userLicenses.renewableLicenses.pagesLoaded || [];
        if (!contToken && contToken !== 0) {
          dispatch(setRenewableLicensesLoading(false));
          return;
        }
        if (pagesLoaded.includes(contToken)) {
          dispatch(setRenewableLicensesLoading(false));
          return;
        }
      }

      const accessToken = selectCurrentIDToken(getState());
      const data = await api.getUserRenewableLicenses(accessToken, contToken);

      dispatch(
        setRenewableLicenses({
          data: [...currentData, ...data.data],
          contToken,
          nextContToken: data.contToken,
          pagesLoaded: [...pagesLoaded, contToken],
        })
      );

      if (data.contToken !== null) {
        dispatch(getUsersRenewableLicensesAsync());
      }
    } catch (error) {
      console.error('error loading renewable licenses', error);
      dispatch(
        setRenewableLicensesFailure(
          'Something went wrong while fetching renewable licneses.'
        )
      );
    }
  };
};
